"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlarmingChartsConnect = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../utils/constants");
var _selectors = require("../../../redux/selectors");
var _devices = require("../../../redux/actions/devices");
var _actions = require("../../../redux/actions");
var _AlarmingChartsContent = require("./AlarmingChartsContent");
var _hooks = require("../../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AlarmingChartsConnect = _ref => {
  let {
    siteId,
    equipmentType,
    activeGroup,
    rangeParams,
    alarmItem,
    onClose
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const equipmentTypeKey = _constants.equipmentKey[_constants.EquipmentTypesByNumber[equipmentType]];
  const equipmentKeyIsPwh = _constants.regKeysForGroupCharts.Pwh.test(equipmentTypeKey);
  const chartId = equipmentKeyIsPwh ? "AlarmPwhChartWrap_".concat(siteId) : "AlarmHtgHxChartWrap_".concat(siteId);
  if (!equipmentTypeKey || !activeGroup) {
    // eslint-disable-next-line no-console
    console.error('Missing mandatory parameter (equipmentType or activeGroup)');
  }
  const equipment = (0, _reactRedux.useSelector)((0, _selectors.selectEquipment)({
    equipmentTypeKey,
    activeGroup
  }));
  (0, _hooks.useSetInitialAlarmData)({
    chartId,
    alarmItem,
    rangeParams,
    equipmentKeyIsPwh,
    equipment
  });
  (0, _react.useEffect)(() => () => {
    dispatch((0, _actions.resetCharts)());
    dispatch((0, _devices.resetDevices)());
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_AlarmingChartsContent.AlarmingChartsContent, {
    equipment: equipment,
    chartId: chartId,
    siteId: siteId,
    equipmentKeyIsPwh: equipmentKeyIsPwh,
    onClose: onClose
  });
};
exports.AlarmingChartsConnect = AlarmingChartsConnect;
AlarmingChartsConnect.propTypes = {
  onClose: _propTypes.default.func,
  siteId: _propTypes.default.string.isRequired,
  equipmentType: _propTypes.default.oneOf(Object.values(_constants.EquipmentTypes)).isRequired,
  activeGroup: _propTypes.default.string.isRequired,
  rangeParams: _propTypes.default.shape({
    from: _propTypes.default.string.isRequired,
    to: _propTypes.default.string.isRequired,
    dateType: _propTypes.default.oneOf(Object.values(_constants.constDateType)).isRequired,
    rangeType: _propTypes.default.oneOf(Object.values(_constants.rangeTypeKey)).isRequired
  }).isRequired,
  alarmItem: _propTypes.default.shape({
    displayNameId: _propTypes.default.number.isRequired,
    equipmentType: _propTypes.default.oneOf(Object.values(_constants.EquipmentTypes)).isRequired,
    equipmentId: _propTypes.default.string.isRequired
  }).isRequired
};